/**
 * The type of (redux) action which signals that a specific App will mount (in
 * React terms).
 *
 * {
 *     type: APP_WILL_MOUNT,
 *     app: App
 * }
 */
export const APP_WILL_MOUNT = 'APP_WILL_MOUNT';
/**
 * The type of (redux) action which signals that a specific App will unmount (in
 * React terms).
 *
 * {
 *     type: APP_WILL_UNMOUNT,
 *     app: App
 * }
 */
export const APP_WILL_UNMOUNT = 'APP_WILL_UNMOUNT';
export const DETAIL_ROOM = 'DETAIL_ROOM';
export const REMIND_WIFI = 'REMIND_WIFI';
export const STRENGTH_NETWORK = 'STRENGTH_NETWORK';
export const UN_REMIND_WIFI = 'UN_REMIND_WIFI';
export const TOGGLE_STATE_OF_WIFI = 'TOGGLE_STATE_OF_WIFI';
